import { render, staticRenderFns } from "./SoftwareVersionHome.vue?vue&type=template&id=bb770814&scoped=true&"
import script from "./SoftwareVersionHome.vue?vue&type=script&lang=js&"
export * from "./SoftwareVersionHome.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareVersionHome.vue?vue&type=style&index=0&id=bb770814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb770814",
  null
  
)

export default component.exports